import React, { useId } from "react";
import styles from "./ImageUploader.module.scss";
import close from "../../../images/icons/AdminPanel/close.svg";
import upload from "../../../images/icons/AdminPanel/sim_card_download.svg";

interface ImageProps {
  images: string[];
  setImage: (value: any) => void;
  handleImageRemove: (value: string) => void;
}

const ImageUploader: React.FC<ImageProps> = ({
  images,
  setImage,
  handleImageRemove,
}) => {
  const id = useId();

  const handleImageUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const newImages: string[] = [];
      const fileReaders: Promise<void>[] = [];

      Array.from(files).forEach((file) => {
        const reader = new FileReader();
        const fileReadPromise = new Promise<void>((resolve, reject) => {
          reader.onloadend = () => {
            if (reader.result) {
              newImages.push(reader.result as string);
              resolve();
            } else {
              reject(new Error("Failed to read file"));
            }
          };
          reader.onerror = () => {
            reject(new Error("Failed to read file"));
          };
          reader.readAsDataURL(file); // Преобразуем файл в Base64
        });

        fileReaders.push(fileReadPromise);
      });

      Promise.all(fileReaders)
        .then(() => {
          setImage((prevImages: any) => [...prevImages, ...newImages]);
        })
        .catch((error) => {
          console.error("Error reading files:", error);
        });
    }
  };

  return (
    <div className={styles.container}>
      <label htmlFor={id} className={styles.conteinerLabel}>
        <input
          id={id}
          type="file"
          accept="image/*"
          multiple
          onChange={handleImageUpload}
          className={styles.inputImages}
          placeholder="Datei auswählen"
        />
        <img src={upload} alt="Icon upload"></img>
        <p className={styles.conteinerLabel_text}>
          Klicken Sie in diesen Bereich, um die Datei herunterzuladen
        </p>
      </label>
      <div className={styles.imageGallery}>
        {images.map((image, index) => (
          <div key={index} className={styles.imageWrapper}>
            <img
              src={close}
              alt="Icon"
              className={styles.removeButton}
              onClick={() => handleImageRemove(image)}
            />
            <img src={image} alt="Photo" className={styles.image} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageUploader;
